import * as React from "react";

function SvgPrevpage(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      width="1em"
      viewBox="0 0 24 24"
      className="prevpage_svg__Svg-sc-1usfroi-0 prevpage_svg__jUuLJy prevpage_svg___6fe5d5efc9b4a07d5c424071ac7cdacb-scss"
      {...props}
    >
      <path fill="none" stroke="currentColor" d="M16 4l-9 8 9 8" />
    </svg>
  );
}

export default SvgPrevpage;
